export const setUserSession = (json) => {
    localStorage.setItem('session',JSON.stringify(json));
}

export const getUserSession = () => {
    let session = JSON.parse(localStorage.getItem('session'));
    return session;
}

export const isAuthenticated = () => {
    let userSession = localStorage.getItem('session');
    return userSession?true:false;
}

export const userLogout = () => {
    localStorage.clear();
}
